import React, { memo, useCallback, useMemo } from 'react'
import { Form, Formik } from 'formik'
import type { GigsafeConfig } from 'src/interfaces/gigsafeConfig'
import { CustomerSettingsFormContent } from './CustomerSettingsFormContent'
import { customerSettingsValidator } from './CustomerSettingsForm.validator'
import { toFormValues } from './CustomerSettingsForm.mapper'
import type { CustomerSettingsFormValues } from './CustomerSettingsForm.interface'

interface Props {
  config: GigsafeConfig | null
  isReadOnly: boolean
  onSubmit(values: CustomerSettingsFormValues): void
}

const CustomerSettingsFormComponent = ({ config, isReadOnly, onSubmit }: Props) => {
  const initialValues = useMemo(() => {
    return toFormValues(config)
  }, [config])

  const handleSubmit = useCallback(
    (values: CustomerSettingsFormValues) => {
      onSubmit(values)
    },
    [onSubmit],
  )

  return (
    <Formik<CustomerSettingsFormValues>
      initialValues={initialValues}
      validationSchema={customerSettingsValidator}
      onSubmit={handleSubmit}
      enableReinitialize
    >
      <Form>
        <CustomerSettingsFormContent isReadOnly={isReadOnly} />
      </Form>
    </Formik>
  )
}

export const CustomerSettingsForm = memo(CustomerSettingsFormComponent)
